import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import CommunityShowcase from './components/CommunityShowcase';
// import InnovationTicker from './components/InnovationTicker';
import SocialProofSection from './components/SocialProofSection';
import FloatingNavigation from './components/FloatingNavigation';

const AdaptiveHomepage = () => {
  useEffect(() => {
    // Smooth scroll behavior for the entire page
    document.documentElement.style.scrollBehavior = 'smooth';
    
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Dream Coders Club - Where Dreams Meet Code, and Potential Becomes Reality</title>
        <meta 
          name="description" 
          content="Join a community-driven platform that bridges individual learning aspirations with institutional transformation needs. Master AI, Robotics, and Coding through hands-on projects and real-world applications." 
        />
        <meta name="keywords" content="AI learning, robotics education, coding bootcamp, programming courses, machine learning, community learning, tech education, career transformation" />
        <meta property="og:title" content="Dream Coders Club - Where Dreams Meet Code" />
        <meta property="og:description" content="Transform your career with AI, Robotics, and Coding education. Join 15,000+ learners in our community-driven platform." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dreamcodersclub.com/adaptive-homepage" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Dream Coders Club - Where Dreams Meet Code" />
        <meta name="twitter:description" content="Transform your career with AI, Robotics, and Coding education. Join 15,000+ learners in our community-driven platform." />
        <link rel="canonical" href="https://dreamcodersclub.com/adaptive-homepage" />
      </Helmet>

      <div className="min-h-screen bg-background text-foreground">
        {/* Header */}
        <Header />

        {/* Main Content */}
        <main className="relative">
          {/* Hero Section */}
          <div id="hero">
            <HeroSection />
          </div>

          {/* Community Showcase */}
          <div id="community">
            <CommunityShowcase />
          </div>

          {/* Social Proof Section */}
          <div id="success">
            <SocialProofSection />
          </div>

          {/* Innovation Ticker */}
          {/* <InnovationTicker /> */}

          {/* Floating Navigation */}
          <FloatingNavigation />
        </main>

        {/* Footer */}
        <footer className="bg-primary border-t border-border">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="grid md:grid-cols-4 gap-8">
              {/* Company Info */}
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-accent to-cyber-purple flex items-center justify-center">
                    <span className="text-white font-bold text-sm">DC</span>
                  </div>
                  <span className="text-lg font-bold text-foreground">Dream Coders Club</span>
                </div>
                <p className="text-muted-foreground text-sm">
                  Transforming education through AI and Robotics innovation. Building tomorrow's workforce today.
                </p>
              </div>

              {/* Solutions */}
              <div>
                <h3 className="text-foreground font-semibold mb-4">Follow Us</h3>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li><a href="https://www.linkedin.com/company/dreamcodersclub" target = "_blank" className="hover:text-accent transition-colors">LinkedIn</a></li>
                  {/* <li><a href="#" className="hover:text-accent transition-colors">Corporate Training</a></li>
                  <li><a href="#" className="hover:text-accent transition-colors">Government Programs</a></li>
                  <li><a href="#" className="hover:text-accent transition-colors">Custom Solutions</a></li> */}
                </ul>
              </div>

              {/* Resources */}
              <div>
                <h3 className="text-foreground font-semibold mb-4">Free Resources</h3>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li><a href="#" className="hover:text-accent transition-colors">Python Beginner's Guide</a></li>
                  {/* <li><a href="#" className="hover:text-accent transition-colors">Case Studies</a></li>
                  <li><a href="#" className="hover:text-accent transition-colors">ROI Calculator</a></li>
                  <li><a href="#" className="hover:text-accent transition-colors">Industry Reports</a></li> */}
                </ul>
              </div>

              {/* Contact */}
              <div>
                <h3 className="text-foreground font-semibold mb-4">Contact</h3>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li>dreamcodersclub99@gmail.com</li>
                  <li>+91 99208 85753</li>
                </ul>
              </div>
            </div>

            <div className="border-t border-border mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
              <p className="text-sm text-muted-foreground">
                © {new Date().getFullYear()} Clusterize Learning LLP. All rights reserved.
              </p>
              {/* <div className="flex space-x-6 mt-4 md:mt-0">
                <a href="#" className="text-sm text-muted-foreground hover:text-accent transition-colors">Privacy Policy</a>
                <a href="#" className="text-sm text-muted-foreground hover:text-accent transition-colors">Terms of Service</a>
                <a href="#" className="text-sm text-muted-foreground hover:text-accent transition-colors">Security</a>
              </div> */}
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default AdaptiveHomepage;